if (!customElements.get('product-share')) {
  customElements.define(
    'product-share',
    class ProductShare extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          urlInput: this.querySelector('input'),
        };

        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;
      }

      connectedCallback() {
        // Initialize the AbortController
        this.abortController = new AbortController();

        this.btnCopy = this.querySelector('.btn-copy');
        if (this.btnCopy) {
          this.btnCopy.addEventListener('click', this.copyToClipboard.bind(this), {
            signal: this.abortController.signal,
          });
        }
      }

      copyToClipboard(evt) {
        evt.preventDefault();

        navigator.clipboard.writeText(evt.target.previousElementSibling.value);
        this.btnCopy.classList.add('copied');
        this.btnCopy.innerText = evt.target.dataset.copiedText;
      }

      updateUrl(url) {
        this.urlToShare = url;
        this.elements.urlInput.value = url;
      }

      disconnectedCallback() {
        this.abortController.abort();
      }
    }
  );
}

/* Botones del modal que no son un simple enlace (snippets/social-sharing.liquid):
   - [data-share-native]: hoja de compartir del sistema (solo si el navegador la tiene).
   - [data-share-instagram]: Instagram no admite enlaces de "compartir" desde la web.
     El boton es un enlace real a Instagram Direct (target=_blank, asi no lo frena el
     bloqueador de emergentes y en movil abre la app). Aqui solo se copia el enlace
     del producto al portapapeles y se avisa en el propio boton para que lo pegue. */
(function () {
  if (window.__espejoledShareExtras) return;
  window.__espejoledShareExtras = true;

  var canNativeShare = typeof navigator.share === 'function';

  function shareData(btn) {
    return { title: btn.dataset.shareTitle || document.title, url: btn.dataset.shareUrl || location.href };
  }

  function revealNativeButtons(root) {
    if (!canNativeShare) return;
    (root || document).querySelectorAll('[data-share-native][hidden]').forEach(function (btn) {
      btn.hidden = false;
    });
  }

  function copyLink(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      try {
        var tmp = document.createElement('textarea');
        tmp.value = text;
        tmp.setAttribute('readonly', '');
        tmp.style.position = 'fixed';
        tmp.style.opacity = '0';
        document.body.appendChild(tmp);
        tmp.select();
        document.execCommand('copy');
        document.body.removeChild(tmp);
        resolve();
      } catch (e) {
        reject(e);
      }
    });
  }

  document.addEventListener('click', function (evt) {
    var nativeBtn = evt.target.closest('[data-share-native]');
    if (nativeBtn && canNativeShare) {
      evt.preventDefault();
      navigator.share(shareData(nativeBtn)).catch(function () {});
      return;
    }

    var igBtn = evt.target.closest('[data-share-instagram]');
    if (!igBtn) return;
    // No se cancela el clic: el enlace abre Instagram Direct en otra pestana/app.
    var data = shareData(igBtn);
    copyLink(data.url).then(function () {
      var links = igBtn.closest('.sharing__links');
      var note = links && links.nextElementSibling;
      if (note && note.hasAttribute('data-share-note')) note.hidden = false;
      var label = igBtn.querySelector('[data-share-label]');
      if (!label || igBtn.classList.contains('is-copied')) return;
      var original = label.textContent;
      label.textContent = igBtn.dataset.copiedText || original;
      igBtn.classList.add('is-copied');
      setTimeout(function () {
        label.textContent = original;
        igBtn.classList.remove('is-copied');
      }, 3000);
    }).catch(function () {});
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { revealNativeButtons(); });
  } else {
    revealNativeButtons();
  }
  document.addEventListener('shopify:section:load', function (evt) { revealNativeButtons(evt.target); });
})();
